const sameMessageId = (left, right) =>
  left !== null &&
  left !== undefined &&
  right !== null &&
  right !== undefined &&
  String(left) === String(right);

export const updateInternalNoteInThread = (threadDetail, messageId, content) => {
  const messages = (threadDetail?.messages || []).map((message) =>
    sameMessageId(message?.message_id, messageId)
      ? { ...message, content }
      : message,
  );
  const lastMessage = messages[messages.length - 1];

  return {
    ...(threadDetail || {}),
    messages,
    ...(sameMessageId(lastMessage?.message_id, messageId)
      ? { last_msg_content: content }
      : {}),
  };
};

export const deleteInternalNoteFromThread = (threadDetail, messageId) => {
  const currentMessages = threadDetail?.messages || [];
  const deletedWasLast = sameMessageId(
    currentMessages[currentMessages.length - 1]?.message_id,
    messageId,
  );
  const messages = currentMessages.filter(
    (message) => !sameMessageId(message?.message_id, messageId),
  );
  const lastMessage = messages[messages.length - 1];

  return {
    ...(threadDetail || {}),
    messages,
    ...(deletedWasLast
      ? {
          last_msg_content: lastMessage?.content || "",
          last_msg_on: lastMessage?.created_at || threadDetail?.created_at,
          last_msg_type: lastMessage?.sender_type?.slice(0, 1) || "",
        }
      : {}),
  };
};
